<template>
  <base-table
    title="Crew"
    item-title="Crew Member"
    get-url="/byvessel"
    :headers="headers"
    :url="url"
    :item="crewMember"
    :item-id="crewMember.vesselCrewId"
    :get-id="id"
    @set-item="setItem"
  >
    <v-text-field
      v-model="crewMember.firstname"
      :rules="[rules.required]"
      label="First Name"
      required
    ></v-text-field>
    <v-text-field
      v-model="crewMember.lastname"
      :rules="[rules.required]"
      label="Last Name"
      required
    ></v-text-field>
    <v-text-field
      v-model="crewMember.position"
      :rules="[rules.required]"
      label="Position"
      required
    ></v-text-field>
  </base-table>
</template>

<script>
import ObjectType from '@/services/Objects.js'
import BaseTable from '@/components/tables/BaseTable.vue'
import Validation from '@/mixins/validation.js'

export default {
  name: 'VesselCrewTable',
  components: {
    BaseTable
  },
  mixins: [Validation],
  props: {
    id: String
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Position', value: 'position' },
        { text: 'Actions', value: 'action', width: '100px' }
      ],
      crewMember: {
        firstname: '',
        lastname: '',
        position: '',
        vesselId: this.id
      },
      url: ObjectType.VesselCrew
    }
  },
  methods: {
    setItem(item) {
      this.crewMember = Object.assign({}, item)
    }
  }
}
</script>

<style scoped></style>
